module.exports = __webpack_public_path__ + "img/xtractive-gris.ade91697.png";